module.exports = "/images/location.svg?4bb778190f9d78f66625c187fe0311cc";